import PageRVDefenderInventory from "./PageRVDefenderInventory.vue";

const routes = {
  organization: [
    {
      path: "rvdefender-inventory",
      name: "RVDefenderInventory",
      component: PageRVDefenderInventory,
    },
  ],
};

export default routes;
